// 导航条顶边自动滑到可视区函数
// @ element 元素
// @ scrollDomClass 滑动盒子元素
// @ ScreenDistance 元素滑动之后离屏幕边距
function autoNavBar (element,scrollDomClass,ScreenDistance){
        const  left = element.getBoundingClientRect().left
        const  right = element.getBoundingClientRect().right
        const clientWidth = window.innerWidth || document.documentElement.clientWidth
        const clientRight = clientWidth-right
        if(clientRight < ScreenDistance){
          let distance 
          if(clientRight<0){
               distance = Math.abs(clientRight)+ScreenDistance
           }else{
               distance = ScreenDistance - clientRight
           }
           document.getElementsByClassName(scrollDomClass)[0].scrollLeft += distance
        }
        if(left<ScreenDistance){
          let distance
          if(left<0){
            distance = Math.abs(left)+ScreenDistance
          }else{
            distance = ScreenDistance - left
          }
          document.getElementsByClassName(scrollDomClass)[0].scrollLeft -= distance
        }
  } 

  function isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
          return true;
      }
      if (/android/i.test(userAgent)) {
          return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return true;
      }
      return false;
  }

  if(isMobileDevice()){
      document.addEventListener('touchstart', handleTouchStart, false);        
      document.addEventListener('touchmove', handleTouchMove, false);
       
      let startY = 0; // 初始Y坐标
      let isScrollingVertically = false; // 是否为竖向滑动
       
      function handleTouchStart(evt) {
          // 记录触摸开始时的Y坐标
          startY = evt.touches[0].clientY;
      }
       
      function handleTouchMove(evt) {
          // 阻止默认滚动行为，以便我们可以检测滑动
          evt.preventDefault();
          
          // 获取当前触摸点的Y坐标
          let currentY = evt.touches[0].clientY;
          let diffY = currentY - startY; // 计算Y方向上的差异
          
          // 判断是否为竖向滑动，这里以滑动距离的绝对值大于10像素为例
          if (Math.abs(diffY) > 20) {
              isScrollingVertically = true; // 设置为竖向滑动
              startY = currentY; // 更新开始Y坐标为当前Y坐标，以便下一次计算
          } else {
              isScrollingVertically = false; // 重置为非竖向滑动
          }
          
          // 根据需要处理滑动事件，例如：
          if (isScrollingVertically) {
              scrollStatus = 'auto'
          } else {
      
          }
      }
    
      //模拟器手机端用，真机注释
      // document.addEventListener('wheel', function(event){
      //   scrollStatus = 'auto'
      // })
  }else{
      document.addEventListener('wheel', function(event){
        scrollStatus = 'auto'
      })
  }



/**
 * 自动感&手动点击应导航条----------------------------------------
 *
 * 使用案例
 *
 * HTML：
 *
 * <div class="section-nav" tag="Thermal">...</div>
 * <div class="section-nav" tag="zulusLRF">...</div>
 *
 * <div id="Thermal">...</div>
 * <div id="zulusLRF">...</div>
 * initAutoNavBar([
 *     'Thermal',
 *     'zulusLRF',
 *     'scop4K',
 *     'bundleSection',
 *     'Sitewide'
 * ],0.5);
 *
 * 功能：
 * 1. 页面滚动自动判断当前模块
 * 2. 自动切换对应 Tab
 * 3. 自动让当前 Tab 滑入导航可视区域
 * 4. 支持 PC 鼠标滚动
 * 5. 支持手机触摸滚动
 * 6. 支持点击导航后 smooth 滚动
 * 7. 点击导航时不会和自动感应互相抢 active
 *
 * @param {Array<String>} sectionIDs 模块 ID 数组
 * @param {Number<Ratio>} Ratio 激活线位置,如：0.35 = 屏幕高度的 35%,数字越小：Tab 越早切换;数字越大：Tab 越晚切换
 */
function initAutoNavBar(sectionIDs,Ratio) {
    if (!Array.isArray(sectionIDs)) {
        sectionIDs = [sectionIDs];
    }

    if (!sectionIDs.length) {
        console.warn('[autoNavBar] 没有传入模块 ID');
        return;
    }

    //   获取导航条
    const navBox = document.querySelector('.nav-box');

    if (!navBox) {
        console.warn('[autoNavBar] 找不到 .nav-box');
        return;
    }


   // 获取所有模块

    const sections = sectionIDs
        .map(id => document.getElementById(id))
        .filter(Boolean);


    if (!sections.length) {
        console.warn(
            '[autoNavBar] 没有找到任何模块：',
            sectionIDs
        );
        return;
    }


    // 获取所有 Tab

    const tabs = Array.from(
        navBox.querySelectorAll('.section-nav')
    );


    if (!tabs.length) {
        console.warn(
            '[autoNavBar] 找不到 .section-nav'
        );
        return;
    }


    /* =====================================================
     * 配置项
     * ===================================================== */

    const config = {
        activationRatio: Ratio,


        /**
         * 自动滚动导航时，
         * 当前 Tab 距离导航左右边缘的距离
         */
        navDistance: 20,


        /**
         * 点击导航后的最大锁定时间
         *
         * 防止 smooth scroll 过程中
         * 自动感应抢走 active
         */
        clickLockTime: 1000

    };


    /* =====================================================
     * 当前 active
     * ===================================================== */

    let currentActiveID = null;


    /* =====================================================
     * 点击导航后的锁定状态
     * ===================================================== */

    let isManualScrolling = false;

    let manualScrollTimer = null;


    /* =====================================================
     * 获取对应 Tab
     * ===================================================== */

    function getTab(sectionID) {

        return tabs.find(tab => {

            return tab.getAttribute('tag') === sectionID;

        });

    }


    /* =====================================================
     * 设置 Active
     * ===================================================== */

    function setActive(sectionID, autoScrollNav = true) {

        if (!sectionID) {
            return;
        }


        /**
         * 如果本身就是当前 Tab，
         * 就不用重复操作。
         */
        if (currentActiveID === sectionID) {
            return;
        }


        currentActiveID = sectionID;


        const currentTab = getTab(sectionID);


        if (!currentTab) {
            return;
        }


        /* -----------------------------------------------
         * 切换 active
         * ----------------------------------------------- */

        tabs.forEach(tab => {

            tab.classList.toggle(
                'nav-active',
                tab === currentTab
            );

        });


        /* -----------------------------------------------
         * 自动移动导航条
         * ----------------------------------------------- */

        if (autoScrollNav) {

            autoNavBar(
                currentTab,
                'nav-box',
                config.navDistance
            );

        }

    }


    /* =====================================================
     * 判断当前应该 Active 哪个模块
     * ===================================================== */

    function checkCurrentSection() {

        /**
         * 点击导航后的 smooth scroll
         * 暂时不要让自动感应修改 Tab
         */
        if (isManualScrolling) {
            return;
        }


        const viewportHeight =
            window.innerHeight ||
            document.documentElement.clientHeight;


        /**
         * 激活线
         */
        const activationLine =
            viewportHeight * config.activationRatio;


        let activeSection = null;


        /**
         * 从前往后检查
         *
         * 最后一个 top <= activationLine 的模块
         * 就是当前模块。
         */
        sections.forEach(section => {

            const rect =
                section.getBoundingClientRect();


            if (rect.top <= activationLine) {

                activeSection = section;

            }

        });

        /**
         * 如果还没有任何模块经过激活线，
         * 默认第一个模块。
         */
        if (!activeSection) {

            activeSection = sections[0];

        }


        if (activeSection) {

            setActive(
                activeSection.id,
                true
            );

        }

    }


    /* =====================================================
     * scroll 性能优化
     * ===================================================== */

    let ticking = false;


    function handleScroll() {

        if (ticking) {
            return;
        }


        ticking = true;


        requestAnimationFrame(() => {

            checkCurrentSection();

            ticking = false;

        });

    }


    /* =====================================================
     * 监听页面滚动
     * ===================================================== */

    window.addEventListener(
        'scroll',
        handleScroll,
        {
            passive: true
        }
    );


    /* =====================================================
     * 点击导航
     * ===================================================== */

    tabs.forEach(tab => {

        tab.addEventListener('click', function () {

            const sectionID =
                this.getAttribute('tag');


            const targetSection =
                document.getElementById(sectionID);


            if (!targetSection) {
                return;
            }


            /**
             * 开启手动滚动锁定
             */
            isManualScrolling = true;


            clearTimeout(manualScrollTimer);


            /**
             * 点击之后立即切换 active
             *
             * 注意：
             * 这里 false 表示不要让导航条再次横向滚动
             */
            setActive(
                sectionID,
                false
            );


            /**
             * 你的导航 sticky top：
             *
             * PC = 60px
             * Mobile = 50px
             *
             * 离顶部 200px 偏移。
             */
            const scrollTop =
                targetSection.getBoundingClientRect().top +
                window.scrollY -
                200;

            window.scrollTo({

                top: Math.max(
                    0,
                    scrollTop
                ),

                behavior: 'smooth'

            });


            /**
             * smooth scroll 没有原生完成回调，
             * 所以通过 debounce 判断用户是否停止滚动。
             */
            function unlock() {

                clearTimeout(
                    manualScrollTimer
                );


                manualScrollTimer =
                    setTimeout(() => {

                        isManualScrolling = false;


                        /**
                         * 解锁后重新判断一次
                         */
                        checkCurrentSection();

                    }, 120);

            }


            /**
             * 给 smooth scroll 留出时间。
             *
             * 每次 scroll 都重新计时。
             */
            const manualScrollHandler = () => {

                unlock();

            };


            window.addEventListener(
                'scroll',
                manualScrollHandler,
                {
                    passive: true
                }
            );


            /**
             * 最长锁定时间
             */
            setTimeout(() => {

                isManualScrolling = false;


                window.removeEventListener(
                    'scroll',
                    manualScrollHandler
                );


                checkCurrentSection();

            }, config.clickLockTime);

        });

    });

    window.addEventListener(
        'resize',
        () => {

            requestAnimationFrame(() => {

                checkCurrentSection();

            });

        }
    );


    /* =====================================================
     * 初始化
     *
     * 页面加载之后立即判断一次
     * ===================================================== */

    if (
        document.readyState === 'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            () => {

                checkCurrentSection();

            },
            {
                once: true
            }
        );

    } else {

        checkCurrentSection();

    }


    /* =====================================================
     * 返回销毁方法
     * ===================================================== */

    return function destroy() {

        window.removeEventListener(
            'scroll',
            handleScroll
        );

        window.removeEventListener(
            'resize',
            checkCurrentSection
        );

    };

}

